import {IPlannerPropertyRoomExposureSide} from "../../../types/planner_property/IPlannerPropertyRoomExposureSide";
import {IPlannerRoomNames} from "../../../types/planner_property/IPlannerRoomNames";
import {RoomsNormalized} from "../get_planner_multi_world_side_rooms_description";
import {normalizePlannerPropertyRoomTypes} from "../normalize_planner_property_room_types";

type RoomWithExposure = ReturnType<typeof normalizePlannerPropertyRoomTypes>[number];

export type RoomWithRequiredExposure = Omit<RoomWithExposure, "roomTypeNormalized" | "exposure"> & {
    exposure: IPlannerPropertyRoomExposureSide[];
    roomTypeNormalized: IPlannerRoomNames;
};

export const getOnlyRoomsWithExposure = (rooms: RoomsNormalized) => {
    return rooms.filter((room) => room.roomTypeNormalized && Array.isArray(room.exposure) && room.exposure.length > 0) as RoomWithRequiredExposure[];
};
import {IPlannerPropertyRoomExposureSide} from "../../../types/planner_property/IPlannerPropertyRoomExposureSide";
import {IPlannerRoomNames} from "../../../types/planner_property/IPlannerRoomNames";
import {RoomsNormalized} from "../get_planner_multi_world_side_rooms_description";
import {normalizePlannerPropertyRoomTypes} from "../normalize_planner_property_room_types";

type RoomWithExposure = ReturnType<typeof normalizePlannerPropertyRoomTypes>[number];

export type RoomWithRequiredExposure = Omit<RoomWithExposure, "roomTypeNormalized" | "exposure"> & {
    exposure: IPlannerPropertyRoomExposureSide[];
    roomTypeNormalized: IPlannerRoomNames;
};

export const getOnlyRoomsWithExposure = (rooms: RoomsNormalized) => {
    return rooms.filter((room) => room.roomTypeNormalized && Array.isArray(room.exposure) && room.exposure.length > 0) as RoomWithRequiredExposure[];
};
